import React from 'react'
import '../styles/article.css'

const EchoesCH4 = () => {
    return (
        <div className='echoes-chapter'>
            <h1 className='ec-h1'>Chapter 4: The It Factor</h1>

            <p>The first round of the competition was reserved for the smallest schools—those
                whose entire student bodies might fit into a single classroom at a larger school. The
                first four show choirs represented schools with fewer than 100 students. The next
                four came from schools with no more than 200. It was humbling to think of the
                challenges these programs must have faced just to get here, to stand under the lights
                of the Cadillac Palace Theater.</p>
            <p>As I scanned the program, I noticed the schools came from far and wide: two from
                North Dakota, one from Montana, two from Wisconsin, one from Maine, one from
                Iowa, and one from Kentucky. I had no idea what to expect. Their names were
                unfamiliar, and their resources were surely limited. But as the performances began, I
                quickly realized these students had something far more powerful than budgets or
                flashy props: heart.</p>
            <p>The group from Kentucky captured everyone’s attention. Their school had only 70
                students in the entire student body, and yet, more than half of them were on
                stage—28 singers, 8 instrumentalists. Their choir director wasn’t just a music
                teacher; he taught freshman English, agriculture, and driver’s education. They had
                choreographed their own routines and scraped together enough money to hire a
                graduate student from the University of Kentucky to arrange their music. Their
                show, Over the Moon, was a creative masterpiece.</p>

            <p>Each song in their set followed their theme: Fly Me to the Moon, Moon River,
                Walking on the Moon, Blue Moon. They even wrote their own lyrics to Beethoven’s
                Moonlight Sonata, transforming the classical piano piece into something haunting
                and lyrical. They ended with Blue Moon of Kentucky, a tribute to their roots. The set
                was simple—stacked vintage televisions from the ’50s and ’60s, each screen playing
                footage of the Apollo 11 mission. It wasn’t elaborate, but it didn’t need to be. Their
                unity, their passion—it filled the theater like a light, washing over the audience and
                leaving us spellbound.</p>
            <p>Their costumes were $18 Halloween orange and blue astronaut suits, and yet they
                moved with a grace and confidence that transcended the fabric. As they performed, I
                felt a lump rise in my throat. It wasn’t just their sound, though they were technically
                flawless. It wasn’t just their sharp, synchronized dancing, either. It was their
                spirit—the intangible energy of a group moving as one, driven by a shared purpose.
                It was a reminder that "small" doesn’t mean "less than." Small is just small. What you
                make of it is what matters.</p>
            <p>I sat there, taking in every note, every movement. And somewhere in the quiet of
                my heart, I felt a stirring of encouragement. I had been so preoccupied with what
                the future might hold for me. Frank was gone, and I hadn’t worked outside the home
                in 18 years. What could I possibly offer? But as I watched those students make magic
                with so little, I realized the answer: you take what you have and create something
                beautiful. Maybe this wasn’t just their lesson; maybe it was mine, too.
                Barbara, sitting beside me, had been quiet during the performances. I had feared
                she might talk through every group, but she was taking detailed notes, much like
                Frank used to. After the second group finished, she leaned over and explained that
                she was making notes for Ebony. Barbara wanted Ebony to double major in
                performance and music education.</p>

            <p>“You always need a backup plan,” she said, her tone thoughtful. “Sometimes Plan B
                has to become Plan A.”</p>
            <p>She told me about a famous opera singer whose career was cut short when his vocal
                cords were damaged by a scalding cup of tea. He had graduated from Julliard with a
                performance certificate but couldn’t teach because he lacked the additional seven
                credit hours needed for certification. “If Ebony ever needs to revisit how to make a
                choral performance work,” Barbara said, “she’ll have my notes from today.”</p>
            <p>Her words hit me harder than I expected. Just seven days ago, I wouldn’t have
                thought twice about Plan B. But now? The idea loomed over me like a shadow I
                couldn’t escape. I had a degree in computer science, but my skills were outdated.
                The world had moved on, leaving me behind with my apple spice cake and Brazilian
                pot roast recipes. What was I supposed to do now? I told myself I wouldn’t think
                about it until next week, but here it was, staring me in the face.</p>

            <p>When the Kentucky choir finished, Barbara turned to me. “So, who’s your pick?
                Montana or Kentucky?”</p>
            <p>“Kentucky,” I said without hesitation.</p>
            <p>She nodded, smiling. “I agree. They had the ‘it’ factor.”</p>

            <p>“The ‘it’ factor?” I asked, intrigued.</p>
            <p>Barbara’s expression grew thoughtful. “The ‘it’ factor is both seen and felt. It’s that
                rare magic when something reaches you on every level—sight, sound, emotion.
                Most things in life are one or the other, but when you get both... well, that’s when
                you’ve got it.”</p>
            <p>She paused, then turned to me with a surprising intensity. “You know, from the
                moment I met you, I could tell you had the ‘it’ factor. Wisdom and soul, all wrapped
                up together. I believe we’re going to be lifelong friends.”</p>

            <p>Her words caught me off guard. I didn’t know what to say, so I excused myself and
                walked out into the lobby. My hands trembled slightly as I pulled out my phone to
                text Tom.</p>
            <p>“I made it to Chicago,” I wrote. “I’m here to cheer you on.”</p>
            <p>His reply came quickly. “I knew you’d come, Mom. It really means a lot to me.”</p>

            <p>I smiled, a warmth spreading through me. Maybe Barbara was right—about
                Kentucky, about the ‘it’ factor, about everything. The ten-minute bell chimed,
                signaling the next round of performances. I took a deep breath and walked back into
                the theater.</p>




        </div>
    )
}

export default EchoesCH4